import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'https://App.baskeg.com/api',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'api-key': 'KpoKcXyjTCHxPquIyTLByode9ZioJ4NwRh4CAFwY5mgoOtw91iuda1Kh0duBaJkR',
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.log(error)
    return Promise.reject(error);
  }
);

export default axiosInstance;
